import React from 'react';
import styled from 'styled-components';
import PermissionRedirect from '../../components/PermissionRedirect';
import { useNavigate } from 'react-router';
import { IoIosArrowBack } from 'react-icons/io';

const Container = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.whiteColor};
`;

const Title = styled.h1`
  position: relative;
  padding: 30px 0px;
  font-size: 30px;
  font-weight: bold;
  text-align: center;
  color: ${({ theme }) => theme.colors.whiteColor};
  background-color: #d3e8e0;
  @media (max-width: 768px) {
    padding: 20px 0px;
    font-size: 20px;
  }
`;

const Icon = styled.div`
  position: absolute;
  left: 20px;
`;
const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 30px;
  @media (max-width: 768px) {
    padding: 20px;
    gap: 10px;
  }
`;
const Desc = styled.div`
  word-break: keep-all;
  font-size: 16px;
  line-height: 26px;
  @media (max-width: 768px) {
    font-size: 12px;
    line-height: 16px;
  }
`;

const SubTitle = styled.h1`
  word-break: keep-all;
  font-size: 16px;
  line-height: 26px;
  @media (max-width: 768px) {
    font-size: 12px;
    line-height: 16px;
  }
`;

const SubDesc = styled.ul`
  word-break: keep-all;
  font-size: 16px;
  line-height: 26px;
  @media (max-width: 768px) {
    font-size: 12px;
    line-height: 16px;
  }
`;

const PrivacyInfoPage = () => {
  const navigate = useNavigate();
  return (
    <Container>
      <PermissionRedirect />
      <Title>
        <Icon onClick={() => navigate(-1)}>
          <IoIosArrowBack />
        </Icon>
        이용 약관
      </Title>
      <Content>
        <Desc>
          <SubTitle>제1조 ( 목 적 )</SubTitle>
          <SubDesc>
            <li>
              이 약관은 (주)포엔이 운영하는 BERI-Link
              웹사이트(https://beri-link.co.kr/, 이하 "BERI-Link"라 한다)에서
              제공하는 인터넷 관련 서비스 및 기타 부대서비스를 이용함에 있어
              (주)포엔과 이용자의 권리, 의무 및 책임사항을 규정함을 목적으로
              합니다.
            </li>
          </SubDesc>
        </Desc>
        <Desc>
          <SubTitle>제2조 ( 정 의 )</SubTitle>
          <SubDesc>
            <li style={{ display: 'flex', gap: 5 }}>
              <span>①</span>
              <span>
                "BERI-Link"란 (주)포엔이 운영하는 가상의
                사업장(https://beri-link.co.kr/)을 말하며, 아울러 가상의
                사업장을 운영하는 사업자의 의미로도 사용합니다.
              </span>
            </li>
            <li style={{ display: 'flex', gap: 5 }}>
              <span>②</span>
              <span>
                “회원”이란 “BERI-Link”에 접속하여 이 약관에 동의하고 회원 가입을
                완료한 이용자를 말하며, “판매자”와 “구매자”로 나뉩니다.
              </span>
            </li>
            <li style={{ display: 'flex', gap: 5 }}>
              <span>③</span>
              <span>
                "판매자"란 "BERI-Link"를 통해 주로 보유하고 있는 전기차 배터리
                매각 등의 서비스를 이용하려는 자를 말합니다.
              </span>
            </li>
            <li style={{ display: 'flex', gap: 5 }}>
              <span>④</span>
              <span>
                “구매자”란 “회원” 중 “판매자”가 아닌 자로서, "BERI-Link"를 통해
                주로 전기차 배터리매입 관련, 전기차 배터리 영업 정보 획득 등의
                서비스를 이용하려는 자를 말합니다.
              </span>
            </li>
          </SubDesc>
        </Desc>
        <Desc>
          <SubTitle>제3조 ( 서비스의 제공 및 중단 )</SubTitle>
          <SubDesc>
            <li style={{ display: 'flex', gap: 5 }}>
              <span>①</span>
              <span>
                "회사"는 다음과 같은 업무를 수행합니다. <br />
                <span style={{ display: 'flex', gap: 5 }}>
                  <span>1.</span>
                  <span>전기차 배터리 중개 서비스</span>
                </span>
                <span style={{ display: 'flex', gap: 5 }}>
                  <span>2.</span>
                  <span>
                    기타 "회사"가 추가 개발하거나 다른 회사와의 제휴계약 등을
                    통해 "회원"에게 제공하는 일체의 서비스
                  </span>
                </span>
              </span>
            </li>
            <li style={{ display: 'flex', gap: 5 }}>
              <span> ②</span>
              <span>
                "서비스"는 연중무휴, 1일 24시간 제공함을 원칙으로 합니다.
              </span>
            </li>
            <li style={{ display: 'flex', gap: 5 }}>
              <span>③</span>
              <span>
                "회사"는 다음 각호에 해당하는 경우 서비스의 제공을 일시적으로
                중단할 수 있습니다.
                <br />
                <span style={{ display: 'flex', gap: 5 }}>
                  <span>1.</span>
                  <span>"회사"가 사전에 이용자에게 공지하거나 통지한 경우</span>
                </span>
                <span style={{ display: 'flex', gap: 5 }}>
                  <span>2.</span>
                  <span>
                    컴퓨터등 정보통신설비의 보수점검 교체 및 고장, 통신의 두절
                    등의 경우
                  </span>
                </span>
                <span style={{ display: 'flex', gap: 5 }}>
                  <span>3.</span>
                  <span>
                    이용자의 서비스 이용 폭주 등으로 서비스 제공이 불가능한 경우
                  </span>
                </span>
                <span style={{ display: 'flex', gap: 5 }}>
                  <span>4.</span>
                  <span>설비 등을 긴급 복구하여야 할 경우</span>
                </span>
                <span style={{ display: 'flex', gap: 5 }}>
                  <span>5.</span>
                  <span>기간통신사업자가 전기통신서비스를 중지한 경우</span>
                </span>
                <span style={{ display: 'flex', gap: 5 }}>
                  <span>6.</span>
                  <span>기타 "회사"가 합리적으로 제어할 수 없는 경우 등</span>
                </span>
              </span>
            </li>
            <li style={{ display: 'flex', gap: 5 }}>
              <span>④</span>
              <span>
                "회사"는 무료로 제공되는 서비스의 일부 또는 전부를 회사의 정책
                및 운영의 필요에 따라 수정, 중단, 변경할 수 있으며, 사전에
                “회원”에게 고지합니다. 다만, 긴급한 사유가 있는 경우에는 사후
                통지할 수 있습니다.
              </span>
            </li>
          </SubDesc>
        </Desc>
        <Desc>
          <SubTitle>제4조 ( 회원가입 )</SubTitle>
          <SubDesc>
            <li style={{ display: 'flex', gap: 5 }}>
              <span>①</span>
              <span>
                이용자는 "회사"가 정한 가입양식에 따라 회원정보를 기입한 후 이
                약관에 동의한다는 의사표시를 함으로서 회원가입을 신청합니다.
              </span>
            </li>
            <li style={{ display: 'flex', gap: 5 }}>
              <span>②</span>
              <span>
                "회사"는 제1항과 같이 회원으로 가입할 것을 신청한 이용자 중 다음
                각호에 해당하지 않는 한 회원으로 등록합니다.
                <br />
                <span style={{ display: 'flex', gap: 5 }}>
                  <span>1.</span>
                  <span>
                    제5조 제1항에 의거 회원탈퇴한 경우 탈퇴일로부터 30일 이내
                  </span>
                </span>
                <span style={{ display: 'flex', gap: 5 }}>
                  <span>2.</span>
                  <span>
                    가입신청자가 이 약관 제5조 제3항에 의하여 이전에 회원자격을
                    상실한 적이 있는 경우, 다만 제5조 제3항에 의한 회원자격 상실
                    후 3년이 경과한 자로서 "회사"의 회원재가입 승낙을 얻은
                    경우에는 예외로 한다.
                  </span>
                </span>
                <span style={{ display: 'flex', gap: 5 }}>
                  <span>3.</span>
                  <span>등록 내용에 허위, 기재누락, 오기가 있는 경우</span>
                </span>
                <span style={{ display: 'flex', gap: 5 }}>
                  <span>4.</span>
                  <span>
                    회원으로 등록하는 것이 "회사"의 기술상 현저히 지장이 있다고
                    판단되는 경우
                  </span>
                </span>
              </span>
            </li>
            <li style={{ display: 'flex', gap: 5 }}>
              <span>③</span>
              <span>
                회원은 회원가입시 등록한 사항에 변경이 있는 경우, 즉시 전자우편
                또는 기타 방법으로 "회사"에 대하여 그 변경사항을 알려야 합니다.
              </span>
            </li>
          </SubDesc>
        </Desc>
        <Desc>
          <SubTitle>제5조 ( 회원 탈퇴 및 자격상실 등 )</SubTitle>
          <SubDesc>
            <li style={{ display: 'flex', gap: 5 }}>
              <span>①</span>
              <span>
                회원은 언제든지 "회사"에 탈퇴를 요청할 수 있으며 "회사"는 즉시
                회원탈퇴를 처리합니다.
              </span>
            </li>
            <li style={{ display: 'flex', gap: 5 }}>
              <span>②</span>
              <span>
                회원이 다음 각호의 사유에 해당하는 경우, "회사"는 회원자격을
                제한 및 정지시킬 수 있습니다.
                <br />
                <span style={{ display: 'flex', gap: 5 }}>
                  <span>1.</span>
                  <span>가입 신청시에 허위 내용을 등록한 경우</span>
                </span>
                <span style={{ display: 'flex', gap: 5 }}>
                  <span>2.</span>
                  <span>
                    다른 사람의 "회사"이용을 방해하거나 그 정보를 도용하는 등
                    전자거래질서를 위협하는 경우
                  </span>
                </span>
                <span style={{ display: 'flex', gap: 5 }}>
                  <span>3.</span>
                  <span>
                    "회사"를 이용하여 법령과 이 약관이 금지하거나 공서양속에
                    반하는 행위를 하는 경우
                  </span>
                </span>
              </span>
            </li>
            <li style={{ display: 'flex', gap: 5 }}>
              <span>③</span>
              <span>
                "회사"가 회원 자격을 제한 또는 정지 시킨 후, 동일한 행위가
                2회이상 반복되거나 30일 이내에 그 사유가 시정되지 아니하는 경우
                "회사"는 회원자격을 상실시킬 수 있습니다.
              </span>
            </li>
            <li style={{ display: 'flex', gap: 5 }}>
              <span>④</span>
              <span>
                "회사"가 회원자격을 상실시키는 경우에는 회원등록을 말소합니다.
                이 경우 회원에게 이를 통지하고, 회원등록 말소전에 소명할 기회를
                부여합니다.
              </span>
            </li>
          </SubDesc>
        </Desc>
        <Desc>
          <SubTitle>제6조 ( 회원에 대한 통지 )</SubTitle>
          <SubDesc>
            <li style={{ display: 'flex', gap: 5 }}>
              <span>①</span>
              <span>
                "회사"가 회원에 대한 통지를 하는 경우, 회원이 "회사"에 제출한
                전자우편 주소로 할 수 있습니다.
              </span>
            </li>
            <li style={{ display: 'flex', gap: 5 }}>
              <span>②</span>
              <span>
                "회사"는 불특정다수 회원에 대한 통지의 경우 1주일이상 "회사"에
                게시함으로서 개별 통지에 갈음할 수 있습니다.
              </span>
            </li>
          </SubDesc>
        </Desc>
        <Desc>
          <SubTitle>제7조 ( 개인정보보호 및 개인정보 제공 동의 )</SubTitle>
          <SubDesc>
            <li style={{ display: 'flex', gap: 5 }}>
              <span>①</span>
              <span>
                "회사"는 이용자의 정보수집시 구매계약 이행에 필요한 최소한의
                정보를 수집합니다. 다음 사항을 필수사항으로 하며 그 외 사항은
                선택사항으로 합니다. 수집 항목: 이름, 전자우편주소, 희망ID,
                비밀번호, 사용자 구분(구매자, 판매자), 생년월일, 연락처
                (휴대전화번호), 주소, 사업자등록번호, 대표자 성명, 사업장명,
                개업 일자, 사업장 주소, 계좌번호
              </span>
            </li>
            <li style={{ display: 'flex', gap: 5 }}>
              <span>②</span>
              <span>
                "회사"가 이용자의 개인식별이 가능한 개인정보를 수집한 때에는
                반드시 당해 이용자의 동의를 받습니다.
              </span>
            </li>
            <li style={{ display: 'flex', gap: 5 }}>
              <span>③</span>
              <span>
                제공된 개인정보는 당해 이용자의 동의없이 목적 외의 이용이나
                제3자에게 제공할 수 없으며, 이에 대한 모든 책임은 "회사"가
                집니다. 다만, 다음의 경우에는 예외로 합니다.
                <br />
                <span style={{ display: 'flex', gap: 5 }}>
                  <span>1.</span>
                  <span>
                    서비스 제공을 위해 필요한 최소한의 정보(예: 이름, 연락처)를
                    제휴업체에 제공하는 경우, 이 경우 “회사”는 제공받는 자, 제공
                    목적, 제공 항목 등을 사전에 고지하고 동의를 받습니다.
                  </span>
                </span>
                <span style={{ display: 'flex', gap: 5 }}>
                  <span>2.</span>
                  <span>
                    통계작성, 학술연구 또는 시장조사를 위해 특정 개인을 식별할
                    수 없는 형태로 제공하는 경우.
                  </span>
                </span>
                <span style={{ display: 'flex', gap: 5 }}>
                  <span>3.</span>
                  <span>관계법령에 따라 제공이 요구되는 경우</span>
                </span>
              </span>
            </li>
            <li style={{ display: 'flex', gap: 5 }}>
              <span>④</span>
              <span>
                "회사"가 제2항과 제3항에 의해 이용자의 동의를 받아야 하는
                경우에는 개인정보 관리책임자의 신원(소속, 성명 및 전화번호 기타
                연락처), 정보의 수집목적 및 이용목적, 제3자에 대한 정보제공
                관련사항(제공받는자, 제공목적 및 제공할 정보의 내용)등
                "개인정보보호법"이 규정한 사항을 미리 명시하거나 고지해야 하며
                이용자는 언제든지 이 동의를 철회할 수 있습니다.
              </span>
            </li>
            <li style={{ display: 'flex', gap: 5 }}>
              <span>⑤</span>
              <span>
                이용자는 언제든지 "회사"가 가지고 있는 자신의 개인정보에 대해
                열람 및 오류정정을 요구할 수 있으며 "회사"는 이에 대해 지체없이
                필요한 조치를 취할 의무를 집니다. 이용자가 오류의 정정을 요구한
                경우에는 "회사"는 그 오류를 정정할 때까지 당해 개인정보를
                이용하지 않습니다.
              </span>
            </li>
            <li style={{ display: 'flex', gap: 5 }}>
              <span>⑥</span>
              <span>
                "회사"는 개인정보 보호를 위하여 관리자를 한정하여 그 수를
                최소화하며 은행계좌 등 을 포함한 이용자의 개인정보의 분실, 도난,
                유출, 변조 등으로 인한 이용자의 손해에 대하여 모든 책임을
                집니다. <br />
                단, “회사”의 고의 또는 과실이 없는 경우에는 그러하지 않습니다.
              </span>
            </li>
            <li style={{ display: 'flex', gap: 5 }}>
              <span>⑦</span>
              <span>
                "회사" 또는 그로부터 개인정보를 제공받은 제3자는 개인정보의
                수집목적 또는 제공받은 목적을 달성한 때에는 당해 개인정보를
                지체없이 파기합니다.
              </span>
            </li>
          </SubDesc>
        </Desc>
        <Desc>
          <SubTitle>제7조의2(데이터 사용)</SubTitle>
          <SubDesc>
            <li>
              “회사”는 회원이 업로드한 데이터(사진, 진단 결과 등)를 회사의
              연구ㆍ개발, 서비스 개선 및 마케팅 목적으로 활용하려는 경우, 해당
              사용 목적과 사용 방식을 회원에게 사전 고지하고 동의를 얻습니다.
              <br />
              동의는 언제든지 철회할 수 있으며, 철회 시 해당 데이터는 사용되지
              않습니다.
            </li>
          </SubDesc>
        </Desc>
        <Desc>
          <SubTitle>제8조(“회사”의 의무 )</SubTitle>
          <SubDesc>
            <li style={{ display: 'flex', gap: 5 }}>
              <span>1.</span>
              <span>
                “회사”는 법령과 이 약관이 금지하거나 공서양속에 반하는 행위를
                하지 않으며, 이 약관이 정하는 바에 따라 지속적이고 안정적으로
                재화·용역을 제공하는데 최선을 다하여야 합니다.
              </span>
            </li>
            <li style={{ display: 'flex', gap: 5 }}>
              <span>2.</span>
              <span>
                “회사”는 “회원”이 안전하게 인터넷 서비스를 이용할 수 있도록
                “회원”의 개인정보 (신용정보 포함) 보호를 위한 보안 시스템을
                갖추어야 합니다.
              </span>
            </li>
            <li style={{ display: 'flex', gap: 5 }}>
              <span>3.</span>
              <span>
                “회사”는 “회원”이 원하지 않는 영리목적의 광고성 전자우편을
                발송하지 않습니다.
              </span>
            </li>
          </SubDesc>
        </Desc>
        <Desc>
          <SubTitle>제9조(“회원”의 의무)</SubTitle>
          <SubDesc>
            <li>“회원”은 다음 각 호의 행위를 하여서는 안됩니다.</li>
            <li style={{ display: 'flex', gap: 5 }}>
              <span>1.</span>
              <span>
                서비스의 이용 신청, 정보 변경 기타 서비스의 이용과 관련한 허위
                내용의 등록·제공
              </span>
            </li>
            <li style={{ display: 'flex', gap: 5 }}>
              <span>2.</span>
              <span>타인의 정보 도용</span>
            </li>
            <li style={{ display: 'flex', gap: 5 }}>
              <span>3.</span>
              <span>
                “회사” 또는 제3자가 “BERI-Link”에서 작성, 게시한 정보를
                변경·삭제하는 행위
              </span>
            </li>
            <li style={{ display: 'flex', gap: 5 }}>
              <span>4.</span>
              <span>
                “회사”가 정한 정보 이외의 정보(컴퓨터 프로그램 등)의 송신 또는
                게시
              </span>
            </li>
            <li style={{ display: 'flex', gap: 5 }}>
              <span>5.</span>
              <span>
                “회사” 또는 기타 제3자의 저작권, 상표권, 특허권 등 지적재산권,
                프라이버시 기타 법령·계약상 권리를 침해하는 행위
              </span>
            </li>
            <li style={{ display: 'flex', gap: 5 }}>
              <span>6.</span>
              <span>v</span>
            </li>
            <li style={{ display: 'flex', gap: 5 }}>
              <span>7.</span>
              <span>
                외설적이거나 폭력적인 문언, 화상, 음성 기타 공서양속에 반하는
                정보를 “BERI-Link”에 공개, 게시 또는 작성하는 행위
              </span>
            </li>
            <li style={{ display: 'flex', gap: 5 }}>
              <span>8.</span>
              <span>
                법령, 법원의 판결, 결정 혹은 명령 또는 법령상 구속력을 가지는
                행정조치에 위반되거나 공공질서 또는 미풍양속을 저해할 우려가
                있는 행위
              </span>
            </li>
            <li style={{ display: 'flex', gap: 5 }}>
              <span>9.</span>
              <span>
                기타 “회사”가 공지한 정책을 위반하는 행위로서, 서비스의 안정성과
                이용자의 권리를 침해할 우려가 있는 행위
              </span>
            </li>
          </SubDesc>
        </Desc>
        <Desc>
          <SubTitle>제10조(“회원”의 ID·비밀번호에 대한 의무)</SubTitle>
          <SubDesc>
            <li style={{ display: 'flex', gap: 5 }}>
              <span>1.</span>
              <span>ID와 비밀번호의 관리책임은 “회원”에게 있습니다.</span>
            </li>
            <li style={{ display: 'flex', gap: 5 }}>
              <span>2.</span>
              <span>
                “회원”은 자신의 ID 및 비밀번호를 제3자에게 이용하게 해서는
                안됩니다.
              </span>
            </li>
            <li style={{ display: 'flex', gap: 5 }}>
              <span>3.</span>
              <span>
                “회원”이 자신의 ID 및 비밀번호를 도난당하거나 제3자가 사용하고
                있음을 인지한 경우 에는 곧바로 “회사”에 통보하고 “회사”의 안내가
                있는 경우에는 그에 따라야 합니다.
              </span>
            </li>
          </SubDesc>
        </Desc>
        <Desc>
          <SubTitle>제11조(“이용자의 의무)</SubTitle>
          <SubDesc>
            <li>
              이용자는 다음 행위를 하여서는 안되며, 이에 대한 법률적인 책임은
              이용자에게 있습니다.
            </li>
            <div style={{ paddingLeft: 10 }}>
              <li style={{ display: 'flex', gap: 5 }}>
                <span>1.</span>
                <span>신청 또는 변경시 허위내용의 등록</span>
              </li>
              <li style={{ display: 'flex', gap: 5 }}>
                <span>2.</span>
                <span>”BERI-Link“에 게시된 정보의 변경</span>
              </li>
              <li style={{ display: 'flex', gap: 5 }}>
                <span>3.</span>
                <span>
                  "회사"가 정한 정보 이외의 정보(컴퓨터 프로그램 등)를 송신 또는
                  게시
                </span>
              </li>
              <li style={{ display: 'flex', gap: 5 }}>
                <span>4.</span>
                <span>
                  "회사" 기타 제3자의 저작권 등 지적재산권에 대한 침해
                </span>
              </li>
              <li style={{ display: 'flex', gap: 5 }}>
                <span>5.</span>
                <span>
                  "회사" 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위
                </span>
              </li>
              <li style={{ display: 'flex', gap: 5 }}>
                <span>6.</span>
                <span>
                  외설 또는 폭력적인 메시지,화상,음성 기타 공서양속에 반하는
                  정보를 "회사"에 공개 또는 게시하는 행위
                </span>
              </li>
              <li style={{ display: 'flex', gap: 5 }}>
                <span>7.</span>
                <span>
                  서비스와 관련된 설비의 오동작이나 정보 등의 파괴 및 혼란을
                  유발시키는 컴퓨터 바이러스, 기타 다른 컴퓨터 코드, 파일,
                  프로그램 자료를 등록 또는 유포하는 행위
                </span>
              </li>
              <li style={{ display: 'flex', gap: 5 }}>
                <span>8.</span>
                <span>
                  “회사” 또는 서비스의 비공개 영역, “회사”의 컴퓨터 시스템에
                  접근하거나 이를 무단으로 변경하거나 혹은 이용하는 행위
                </span>
              </li>
              <li style={{ display: 'flex', gap: 5 }}>
                <span>9.</span>
                <span>
                  ”회사”의 시스템이나 네트워크의 취약점을 검사, 조사 또는
                  테스트하거나 보안 조치 내지 인증 조치를 위반하거나 우회하는
                  행위
                </span>
              </li>
              <li style={{ display: 'flex', gap: 5 }}>
                <span>10.</span>
                <span>
                  자동 접속 프로그램을 사용하는 등 정상적인 용법과 다른 방법으로
                  서비스를 이용하여 “회사”의 서버에 부하를 일으켜 “회사”의
                  정상적인 서비스를 방해하는 행위
                </span>
              </li>
              <li style={{ display: 'flex', gap: 5 }}>
                <span>11.</span>
                <span>
                  ”회사”와 체결한 별도의 계약에 따라 특별히 허용된 경우가 아닌
                  한, “회사”가 제공한 것으로서 현재 이용 가능한 정식 인터페이스
                  이외의 모든 수단(자동화 여부에 관계없음) 으로 “회사” 또는
                  서비스,
                </span>
              </li>
              <li style={{ display: 'flex', gap: 5 }}>
                <span>12.</span>
                <span>
                  “회사” 또는 서비스상에서 오버로딩(overloading),
                  플러딩(floading) 또는 스패밍 (spamming)을 실행하거나 폭탄
                  메일(mail-bombing)을 전송하는 행위 등을 포함하 여 사용자,
                  호스트 또는 네트워크의 접근을 방해하거나 중단시키는 행위 혹은
                  그러한 방해나 중단을 시도하는 행위
                </span>
              </li>
              <li style={{ display: 'flex', gap: 5 }}>
                <span>13.</span>
                <span>
                  다른 회원의 개인정보를 개인정보 주체의 동의없이 수집, 저장,
                  공개하는 행위
                </span>
              </li>
            </div>
          </SubDesc>
        </Desc>
        <Desc>
          <SubTitle>제12조(연결된 웹사이트와의 관계)</SubTitle>
          <SubDesc>
            <li>
              “회사”의 “BERI-Link”에서 다른 웹사이트가 하이퍼링크(그 대상에는
              문자, 이미지, 영상 등이 포함됩니다) 방식으로 연결된 경우, “회사”는
              연결된 웹사이트가 “회원”과 독자적으로 행하는 재화 등의 거래에
              대하여 보증 책임을 지지 않습니다.
            </li>
          </SubDesc>
        </Desc>
        <Desc>
          <SubTitle>제13조 ( 저작권의 귀속 및 이용제한 )</SubTitle>
          <SubDesc>
            <li style={{ display: 'flex', gap: 5 }}>
              <span>①</span>
              <span>
                "회사"와 하위 "웹사이트"가 하이퍼 링크(예: 하이퍼 링크의
                대상에는 문자, 그림 및 동화상등이 포함됨)방식 등으로 연결된
                경우, 전자를 연결 웹사이트라고 하고 후자를 피연결 웹사이트라고
                합니다.
              </span>
            </li>
            <li style={{ display: 'flex', gap: 5 }}>
              <span>②</span>
              <span>
                연결 웹사이트는 피연결 웹사이트가 독자적으로 제공하는 재화
                용역에 의하여 이용자와 행하는 거래에 대해서 보증책임을 지지
                않는다는 뜻을 연결웹사이트의 사이트에서 명시한 경우에는 그
                거래에 대한 보증책임을 지지 않습니다.
              </span>
            </li>
          </SubDesc>
        </Desc>
        <Desc>
          <SubTitle>14조 ( 분쟁처리 및 분쟁조정 )</SubTitle>
          <SubDesc>
            <li style={{ display: 'flex', gap: 5 }}>
              <span>①</span>
              <span>
                "회사"는 이용자가 제기하는 정당한 의견이나 불만을 반영하고 그
                피해를 보상처리하기 위하여 최선을 다합니다.
              </span>
            </li>
            <li style={{ display: 'flex', gap: 5 }}>
              <span>②</span>
              <span>
                "회사"는 이용자로부터 제출되는 불만사항 및 의견은 우선적으로 그
                사항을 처리합니다. 다만, 신속한 처리가 곤란한 경우에는
                이용자에게 그 사유와 처리일정을 즉시 통보해 드립니다.
              </span>
            </li>
            <li style={{ display: 'flex', gap: 5 }}>
              <span>③</span>
              <span>
                "회사"와 이용자간에 발생한 분쟁은 “전자문서 및 전자거래 기본법”
                제32조 및 동 시행령 제16조에 의해 설치된
                전자거래분쟁조정위원회의 조정을 받을 수 있습니다. 다만 이는
                이용자의 선택 사항이며, 분쟁 해결을 위해 별도의 법적 절차를
                진행할 수 있습니다.
              </span>
            </li>
          </SubDesc>
        </Desc>
        <Desc>
          <SubTitle>제15조 ( 재판권 및 준거법 )</SubTitle>
          <SubDesc>
            <li style={{ display: 'flex', gap: 5 }}>
              <span>①</span>
              <span>
                "회사"와 이용자간에 발생한 분쟁에 관한 소송은 민사소송법에 따라
                관할 법원에 제기합니다.
              </span>
            </li>
            <li style={{ display: 'flex', gap: 5 }}>
              <span>②</span>
              <span>
                "회사"와 이용자간에 제기된 소송에는 한국법을 적용합니다.
              </span>
            </li>
          </SubDesc>
        </Desc>
      </Content>
    </Container>
  );
};

export default PrivacyInfoPage;
